import { Component, Input } from '@angular/core';
import { NgbActiveModal }   from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector   : 'wor-import-progress',
  template: require('./import.progress.component.html')
})
export class ImportProgressComponent {
  @Input() percentage: number;

  // WS-6750. The run's own status, so the modal can say the import is still going after
  // the submit has returned. Before this the modal closed the moment the request came
  // back, which stopped meaning "finished" as soon as the backend stopped blocking.
  @Input() status: string;

  get isQueued () : boolean {
    return this.status === 'queued';
  }

  get isAwaitingDecisions () : boolean {
    return this.status === 'awaiting_decisions';
  }

  constructor (
    public activeModal: NgbActiveModal
  ) {}
}
